import React from 'react';
import { useSelector } from 'react-redux';
import useTranslation from '@src/hooks/useTranslation';
import _ from 'lodash';

import useCurrentCourse from '@src/hooks/useCurrentCourse';
import { QuestionBulletIcon } from 'src/components/common/icon';
import Header from '@src/components/common/header';
import { BlockWrapper } from '@src/components/common/commonStyle';
import BulletListItem from '@src/components/common/bulletListItem';
import { GridContent } from '@src/components/common/bulletListItem/styled';
import { getFaqPages } from '@src/store/selectors/theme';

interface IFaqItem {
	id: string;
	question: string;
	answer: string;
}

const FrequentlyAskedQuestion = (): JSX.Element => {
	const { t } = useTranslation();
	// faqs from theme should be removed after new course editor finished.
	const faqsFromTheme = useSelector(getFaqPages) as IFaqItem[];
	const { currentCourse: { faq: faqsFromCourse } } = useCurrentCourse();
	const faqs = (faqsFromCourse?.length > 0 ?
		_.sortBy(faqsFromCourse, ['index']) :
		faqsFromTheme) || [];
	const hasAnyFaq = faqs?.length > 0;

	return hasAnyFaq && (
		<BlockWrapper>
			<Header text={t('course:information:frequently_asked_question')} />
			<GridContent>
				{
					faqs.map((faq, index) => {
						const itemKey = `${faq.question}_${index}`;
						return (
							<BulletListItem
								key={itemKey}
								title={faq.question}
								content={faq.answer}
								BulletIcon={QuestionBulletIcon}
							/>
						);
					})
				}
			</GridContent>
		</BlockWrapper>
	);
};
export default FrequentlyAskedQuestion;
